module.exports = require("@amplication/code-gen-utils");